import { render, staticRenderFns } from "./_btnEvidence.vue?vue&type=template&id=760b15fe&"
import script from "./_btnEvidence.vue?vue&type=script&lang=js&"
export * from "./_btnEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports